import { useCallback, useContext } from 'react';
import { IsAvailableToApplyContext } from 'app/context/hs/IsAvailableToApplyProvider';

const useIsAvailableToApply = (checkApi) => {
	const { isNonMember, isAvailableToApply, isBirthNone, loingAfterPassIntro } = useContext(IsAvailableToApplyContext);

	return {
		isNonMember,
		isAvailableToApply: useCallback((name, phone) => isAvailableToApply(checkApi, name, phone), [checkApi, isAvailableToApply]),
		isBirthNone,
		loingAfterPassIntro,
	};
};

export default useIsAvailableToApply;
